import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import WelcomeOverlay from './WelcomePage';

// Smart API URL switching
const API_BASE_URL =
    window.location.hostname === "staging187611.digassistant.xyz"
        ? "https://api.digassistant.xyz"
        : window.location.hostname === "digassistant.xyz" || window.location.hostname === "www.digassistant.xyz"
        ? "https://api.digassistant.xyz"
        : "http://localhost:8080";

const FreeDropdown = ({ onShowDiveHistory, GuideComponent }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [showGuide, setShowGuide] = useState(false);
    const navigate = useNavigate();
    const Guide = GuideComponent || WelcomeOverlay;

    const handleLogout = async () => {
        try {
            await fetch(`${API_BASE_URL}/auth/google/logout`, {
                method: "POST",
                credentials: "include",
            });
        } catch (error) {
            console.error("Logout error:", error);
        }
        localStorage.removeItem("welcomeShown"); // Reset welcome overlay on logout
        navigate("/");
    };

    const handleUpgrade = () => {
        navigate("/upgrade");
    };

    const handleSupport = () => {
        navigate("/support");
    };

    const handleInfo = () => {
        navigate("/info");
    };

    return (
        <div className="premium-dropdown" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            {showGuide && <Guide onClose={() => setShowGuide(false)} />}
            {/* Become a member button */}
            <button
                onClick={handleUpgrade}
                style={{
                    background: 'none',
                    border: 'none',
                    color: 'white',
                    padding: '8px 16px',
                    cursor: 'pointer',
                    fontFamily: 'CustomFont',
                    fontSize: '14px',
                    whiteSpace: 'nowrap'
                }}
                onMouseOver={(e) => {
                    e.target.style.color = '#009e4a';
                }}
                onMouseOut={(e) => {
                    e.target.style.color = 'white';
                }}
            >
                Become a member
            </button>

            {/* Burger Menu Button */}
            <button
                className="burger-menu-button"
                onClick={() => setIsOpen(!isOpen)}
                aria-label="Menu"
            >
                <div className={`burger-line ${isOpen ? 'open' : ''}`}></div>
                <div className={`burger-line ${isOpen ? 'open' : ''}`}></div>
                <div className={`burger-line ${isOpen ? 'open' : ''}`}></div>
            </button>

            {/* Dropdown Menu */}
            {isOpen && (
                <div className="dropdown-menu">
                    <button
                        onClick={handleInfo}
                        className="dropdown-item"
                    >
                        Info
                    </button>
                    {GuideComponent && (
                        <button
                            onClick={() => { setShowGuide(true); setIsOpen(false); }}
                            className="dropdown-item"
                        >
                            How to use voyage mode
                        </button>
                    )}
                    <button
                        onClick={handleSupport}
                        className="dropdown-item"
                    >
                        Contact
                    </button>
                    <button
                        onClick={handleLogout}
                        className="dropdown-item"
                    >
                        Logout
                    </button>
                </div>
            )}
        </div>
    );
};

export default FreeDropdown;

